export default __webpack_public_path__ + "static/media/7minfitness@3x.4bbdcfc7.jpg";